import withResponsiveHOC from "components/enhancements/responsive-hoc/responsive-hoc-component";
import DefaultProps from "./default-props";
import SlidingCardGridMobileComponent from "./components/sliding-card-grid-mobile/sliding-card-grid-mobile-component";
import SlidingCardGridBaseComponent from "./components/sliding-card-grid-base/sliding-card-grid-base-component";
const SlidingCardGridComponent = withResponsiveHOC(SlidingCardGridBaseComponent, SlidingCardGridMobileComponent);
SlidingCardGridComponent.defaultProps = DefaultProps;
export default SlidingCardGridComponent;
